import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Interaction } from './interaction.model';

@Injectable({
  providedIn: 'root'
})
export class InteractionsService {

  constructor(private http: HttpClient) { }

  getAllInteractions(): Observable<any> {
    return this.http.get(environment.apiUrl + '/interaction/getAll');
  }

  getOneInteraction(intId: string | number): Observable<any> {
    return this.http.get(environment.apiUrl + '/interaction/getSingle/' + intId );
  }

  addInteraction(interaction: Interaction): Observable<any> {
    return this.http.post(environment.apiUrl + '/interaction/new/', interaction);
  }
  editInteraction(interaction: Interaction): Observable<any> {
    return this.http.put(environment.apiUrl + '/interaction/edit/', {...interaction, interactionId: interaction.id});
  }
}
